import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  canonicalUrl: string;
  ogType?: string;
  structuredData?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  canonicalUrl,
  ogType = 'website',
  structuredData,
}: SEOHeadProps) {
  useEffect(() => {
    const fullTitle = `${title} | 蘑菇影视`;

    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:locale', 'zh_CN', true);
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);

    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', canonicalUrl);

    if (structuredData) {
      let scriptEl = document.querySelector('#structured-data');
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.setAttribute('id', 'structured-data');
        scriptEl.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(structuredData);
    }

    return () => {
      if (structuredData) {
        const scriptEl = document.querySelector('#structured-data');
        if (scriptEl) scriptEl.remove();
      }
    };
  }, [title, description, canonicalUrl, ogType, structuredData]);

  return null;
}